<script>
  import { mapActions } from 'vuex'
  import { TopBar } from '@/components/_shared'
  import { LoadingButton } from '@/components/_shared'

  export default {
    name: 'screens-view',

    components: {
      LoadingButton,
      TopBar
    },

    data () {
      return {
        loading: false
      }
    },

    metaInfo: {
      title: 'Screen Manager'
    }
    ,

    methods: {
      ...
        mapActions('app', [
          'showModal'
        ])
    }
    ,
  }
</script>

<template>
  <div>
    <top-bar title="Screen Manager" icon="bolt">
      <template slot="actions">
        <b-button variant="primary" @click="showModal('ScreenNewModal')">New Screen</b-button>
      </template>
    </top-bar>
    <b-container fluid>
      <div>
        <loading-button variant="primary" loading-label="Please wait..." :is-loading="loading" @click="loading = !loading">
          Click to Load
        </loading-button>
      </div>
    </b-container>
  </div>
</template>
